import {h} from 'preact'
import SearchResults from "../sections/SearchResults";

export default () => {
    return (
        <>
            <SearchResults />
        </>
    )
}